import { render, staticRenderFns } from "./EventRegistrierung.vue?vue&type=template&id=33fca1be&scoped=true&"
import script from "./EventRegistrierung.vue?vue&type=script&lang=js&"
export * from "./EventRegistrierung.vue?vue&type=script&lang=js&"
import style0 from "./EventRegistrierung.vue?vue&type=style&index=0&id=33fca1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fca1be",
  null
  
)

export default component.exports